module.exports = __webpack_public_path__ + "static/img/xinyigon.b3abbe1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/20250724/ruanjian/xinyigon.png
// module id = 9iEy
// module chunks = 35